import {
  ResourceFormFields,
  ResourceTypeEnum,
} from '@/components/resource/ResourceInlineForm';
import { ResourceDTO } from '@/models/Resource';

export const sanitizeFileUnchanged = (
  data: ResourceFormFields,
  dto: Partial<ResourceDTO>,
): Partial<ResourceDTO> => {
  if (data.type !== ResourceTypeEnum.FILE) return dto;
  if (data.resourceFile instanceof File) return dto;
  const { resourceFile, ...rest } = dto;
  return rest;
};
